/* WJW 59B.15 | presentation-only fallback for FAILED Appstle membership thumbnails. */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('wjw-membership-product')) return;
  function inspectImage(img) {
    if (!(img instanceof HTMLImageElement) || !img.matches('.appstle_membership_image img')) return;
    var slot = img.closest('.appstle_membership_image');
    if (!slot) return;
    /* Never substitute an image that loaded correctly. */
    slot.classList.toggle('wjw59b15-icon-fallback', img.complete && img.naturalWidth === 0);
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('.appstle_membership_image img')) inspectImage(root);
    root.querySelectorAll('.appstle_membership_image img').forEach(inspectImage);
  }
  document.addEventListener('error', function (event) { inspectImage(event.target); }, true);
  document.addEventListener('load', function (event) { inspectImage(event.target); }, true);
  scan(document);
  new MutationObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.addedNodes.forEach(scan);
    });
  }).observe(document.body, {childList:true, subtree:true});
})();
